export enum AqdbCompleteFlag {
	COMPLETE = 'O',
	INCOMPLETE = 'N',
}

export enum AqdbConditions {
	T = 'T',
	V = 'V',
}

export enum AqdbMeMoFlag {
	MEASURED_DATAS = 'ME',
	MODELLED_DATA = 'MO',
}
